import React from 'react';
import { Toast as BaseToast } from '@base-ui/react/toast';
import { Icon, Loader } from 'react-frontier';
import style from './style/toast.module.scss';

export const toastManager = BaseToast.createToastManager();

interface ToastData{
	loading?: boolean,
}

var ToastList = ()=>{
	var { toasts } = BaseToast.useToastManager();

	return <React.Fragment>
		{toasts.map(t=>(
			<BaseToast.Root key={t.id} toast={t} className={style.toast} swipeDirection={t.data?.loading ? null : undefined}>
				<BaseToast.Content className={style.container} data-loading={!!t.data?.loading || undefined}>
					{t.data?.loading && <Loader size={18} />}
					<div className={style.text}>
						{!!t.title && <BaseToast.Title className={style.title}>{t.title}</BaseToast.Title>}
						{!!t.description && <BaseToast.Description className={style.contents}>{t.description}</BaseToast.Description>}
					</div>
					{!t.data?.loading && (
						<BaseToast.Close className={style.dismiss}>
							<Icon name='times' />
						</BaseToast.Close>
					)}
				</BaseToast.Content>
			</BaseToast.Root>
		))}
	</React.Fragment>
}

interface ToastProviderProps{
	children?: React.ReactNode,
}

var Provider = (props: ToastProviderProps)=>{
	return <BaseToast.Provider toastManager={toastManager}>
		{props.children}
		<BaseToast.Portal>
			<BaseToast.Viewport className={style.viewport}>
				<ToastList />
			</BaseToast.Viewport>
		</BaseToast.Portal>
	</BaseToast.Provider>
}

var add = (type: string, description: string, title?: string, data?: ToastData)=>{
	return toastManager.add({ type, title, description, data });
}

export default {
	Provider,
	success: (description: string, title?: string)=>add('success', description, title),
	error: (description: string, title?: string)=>add('error', description, title),
	warning: (description: string, title?: string)=>add('warning', description, title),
	info: (description: string, title?: string)=>add('default', description, title),
	loading: (description: string, title?: string)=>add('default', description, title, { loading: true }),
	close: (id?: string)=>toastManager.close(id),
}
